module.exports = __webpack_public_path__ + "static/media/Compensá-intro-icon.9e647a1e.svg";